import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DataService} from '../../../Services/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {StorageService} from '../../../Services/storage.service';
import {Title} from '@angular/platform-browser';
import {DateFilterService} from '../../../Services/dateFilter.service';
import {AppConfigService} from '../../../Services/app-config.service';
import {DatePipe} from '@angular/common';
import {DecimalNewPipe} from '../../common/DecimalNewPipe';
import {ResponseModel} from '../../../DataModels/response-model';
import {ConfirmDialogService} from '../../../Services/confirm-dialog.service';
import {Subscription} from 'rxjs';
import {NgbPaginationConfig} from '@ng-bootstrap/ng-bootstrap';
import {PagerStateService} from '../../../Services/pager-state.service';
import {NgbpaginationConfigService} from '../../../Services/ngbpagination-config.service';
import {BsToastService} from '../../../Services/bs-toast-service';
import {ListPageBase} from '../../list-page-base';

@Component({
  selector: 'app-invoice-recurring',
  templateUrl: './invoice-recurring-list.component.html',
  styleUrls: ['./invoice-recurring-list.component.css'],
  standalone: false
})
export class InvoiceRecurringListComponent extends ListPageBase implements OnInit, AfterViewInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private localStorage: StorageService,
    private tableDataService: DataService,
    private notification: BsToastService,
    private titleService: Title,
    private datePipe: DatePipe,
    private decimalPipe: DecimalNewPipe,
    private dateFilter: DateFilterService,
    private confirmDialogService: ConfirmDialogService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
    // this.vm.selectAllItems = false;
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  vm: any = {};
  hideBatches;
  isLoaded = false;
  paymentId = '';
  statusFilter: 'active' | 'completed' | 'all' = 'active';

  checkAll = false;
  selectedRecords = [];
  subscriptionGroup: Subscription[] = [];




  ngAfterViewInit() {
    this.titleService.setTitle($localize`:Recurring Invoices @@recurringInvoices:Recurring Invoices`);
  }

  ngOnInit() {
    this.restorePagerState();


    this.route.queryParams.pipe().subscribe((params) => {
      this.vm.type = params.type;
      this.vm.list = [];

      //  this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.vm.reverse = -1;
      if (this.vm.type == 'ap') {
        let paramString = '';
        paramString += 'batchType=4';
        paramString += '&recurring=1';
        paramString += '&recurring_status=' + this.statusFilter;
        paramString += '&search=' + (this.vm.entrySearch ? this.vm.entrySearch : '');
        paramString +=
          '&fromDate=' + (this.vm.entryFromDate ? this.dateFilter.GetDateFormat(this.vm.entryFromDate) : '');
        paramString += '&toDate=' + (this.vm.entryToDate ? this.dateFilter.GetDateFormat(this.vm.entryToDate) : '');
        paramString += '&locked=' + this.vm.unappliedOnly;
        // paramString += '&numberOfResults=' + this.localStorage.StorageGet('numberOfResults', '');
        paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
        paramString += '&pageSize=' + this.pageSize;

        this.tableDataService.getData('entry', '?' + paramString).subscribe((result: any) => {
          this.vm.list = [];
          console.log(result);
          this.vm.list = result.Data;
          this.totalRecords = result.totalRecords;

          this.paginate(false);

          // this.convertToNumbers();
        });
      } else {
        let paramString = '';
        paramString += 'batchType=2';
        paramString += '&recurring=1';
        paramString += '&recurring_status=' + this.statusFilter;
        paramString += '&search=' + (this.vm.entrySearch ? this.vm.entrySearch : '');
        paramString +=
          '&fromDate=' + (this.vm.entryFromDate ? this.dateFilter.GetDateFormat(this.vm.entryFromDate) : '');
        paramString += '&toDate=' + (this.vm.entryToDate ? this.dateFilter.GetDateFormat(this.vm.entryToDate) : '');
        paramString += '&locked=' + this.vm.unappliedOnly;
        paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
        paramString += '&pageSize=' + this.pageSize;


        this.tableDataService.getApiListData('entry', '?' + paramString).subscribe((resultAr: ResponseModel) => {
          this.vm.list = [];
          console.log('ar', resultAr);
          this.vm.list = resultAr.Data;
          this.totalRecords = resultAr.totalRecords;
          this.paginate(false);
        });
      }

      this.isLoaded = true;
      this.vm.listInitiated = true;

      this.vm.owingSelected = this.vm.totalSelected = 0;
      this.vm.invoiceToDateOpen = this.vm.invoiceFromDateOpen = false;
      // this.dataTableReady = true;

      //  });
    });
  }

  ngOnDestroy(): void {
    // no dtTrigger to clean up anymore
  }


  convertToNumbers() {
    for (const obj of this.vm.list) {
      obj.detail_total = Number(obj.detail_total) * this.vm.reverse;
      obj.audit_sequence = Number(obj.audit_sequence);
      if (obj.payment_applied_total) {
        obj.payment_applied_total = Number(obj.payment_applied_total) * this.vm.reverse;
      } else {
        obj.payment_applied_total = 0;
      }
    }
  }

  selectItem() {
    this.vm.owingSelected = this.vm.totalSelected = 0;

  }

  search() {
    this.vm.searching = true;
    this.vm.selectAllItems = false;
    if (this.vm.unappliedOnly) {
      this.vm.numberOfResults = 'All';
    }
    if (this.vm.type === 'ap') {
      let paramString = '';
      paramString += 'batchType=4';
      paramString += '&recurring=1';
      paramString += '&recurring_status=' + this.statusFilter;
      paramString += '&search=' + (this.vm.entrySearch ? this.vm.entrySearch : '');
      paramString += '&fromDate=' + (this.vm.entryFromDate ? this.dateFilter.GetDateFormat(this.vm.entryFromDate) : '');
      paramString += '&toDate=' + (this.vm.entryToDate ? this.dateFilter.GetDateFormat(this.vm.entryToDate) : '');
      paramString += '&locked=' + this.vm.unappliedOnly;
      paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
      paramString += '&pageSize=' + this.pageSize;

      this.tableDataService.getApiListData('entry', '?' + paramString).subscribe((result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.vm.listInitiated = true;
        this.vm.searching = false;
      });
    } else {
      let paramString = '';
      paramString += 'batchType=2';
      paramString += '&recurring=1';
      paramString += '&recurring_status=' + this.statusFilter;
      paramString += '&search=' + (this.vm.entrySearch ? this.vm.entrySearch : '');
      paramString += '&fromDate=' + (this.vm.entryFromDate ? this.dateFilter.GetDateFormat(this.vm.entryFromDate) : '');
      paramString += '&toDate=' + (this.vm.entryToDate ? this.dateFilter.GetDateFormat(this.vm.entryToDate) : '');
      paramString += '&locked=' + this.vm.unappliedOnly;
      paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
      paramString += '&pageSize=' + this.pageSize;

      this.tableDataService.getApiListData('entry', '?' + paramString).subscribe((result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.vm.listInitiated = true;
        this.vm.searching = false;
      });
    }
  }

  filter(filter) {
    this.vm.invoiceFilter = Object.assign(this.vm.invoiceFilter, filter);
  }

  checkSelected() {
    const selectedIds = this.vm.list.filter((rec) => rec.selected).map((rec) => rec.id);
    // const selectedRows = this.myGrid.getselectedrowindexes();
    this.vm.recurring = [];
    for (const selectedId of selectedIds) {
      this.vm.recurring.push({
        header_id: selectedId,
      });
    }
    if (!this.vm.recurring) {
      this.notification.showWarningToast(
        $localize`:You must select at least one entry @@youmustselectatleastoneentry:You must select at least one entry`
      );
    }
  }

  // selectRow(recId: any, checked: boolean) {
  //   console.log('rec val:' + recId + ' - ' + checked);
  //   if (!checked) {
  //     this.selectedRecords.forEach((element, index) => {
  //       if (element == recId) {
  //         this.selectedRecords.splice(index, 1);
  //       }
  //     });
  //   } else if (checked) {
  //     this.selectedRecords.push(recId);
  //   }
  //   console.log('selected records' + JSON.stringify(this.selectedRecords));
  // }

  selectRow(rec: any, checked: boolean) {
    // console.log('rec val:' + rec + ' - ' + checked);
    if (this.checkAll && rec) {
      this.checkAll = false;
    }
    if (!checked) {
      this.vm.list.forEach((item) => {
        if (item.id === rec) {
          item.selected = false;
        }
      });
    } else if (checked) {
      this.vm.list.forEach((item) => {
        if (item.id === rec && !item.locked) {
          item.selected = true;
        }
      });
    }
    this.isAllChecked();

    // console.log('single select records' + JSON.stringify(this.vm.list));
  }

  selectAllRows(event: any) {
    if (!event) {
      this.vm.list.forEach((item) => (item.selected = false));
    } else if (event) {
      // this.vm.list.forEach((item) => (item.selected = true));
      this.vm.list.forEach((item) => {
        if (!item.locked) {
          item.selected = true;
        }
      });
    }
    // console.log('all select records: ' + JSON.stringify(this.vm.list));
  }

  isAllChecked(): boolean {
    const retVal = this.vm.list.every((x) => x.selected === true);
    this.checkAll = retVal;
    return retVal;
  }

  confirmDeleteSelected() {
    if (this.vm.list.filter(x => x.selected).length === 0) {
      this.notification.showWarningToast('No records selected to delete!');
      return;
    }

    const messages: string[] = [
      $localize`:Are you sure you want to Delete? @@areyousureyouwanttodelete:Are you sure you want to Delete?`,
      'Selected Count: ' + this.vm.list.filter(x => x.selected).length,
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.deleteSelected();
      },
      () => {
        this.notification.showSuccessToast($localize`:Delete Canceled @@deleteCanceled:Delete Canceled`);
      }
    );
  }


  deleteSelected() {
    // just need to send the header id to the api
    const arrayOfItemsToDelete = [];
    this.vm.list.forEach((x) => {
      if (x.selected) {
        arrayOfItemsToDelete.push({header_id: x.id});
      }
    });

    if (!arrayOfItemsToDelete.length) {
      this.notification.showWarningToast('No records selected to delete!');
      return;
    }
    // console.log('selected recs: ' + JSON.stringify(arrayOfItemsToDelete));

    // makes action button spinner turn while deleting
    this.isLoaded = false;
    // pass array as body in a delete to api entryController
    this.subscriptionGroup.push(this.tableDataService.deleteDataByArray('entry', arrayOfItemsToDelete).subscribe((item: any) => {
      if (item) {
        // console.log(item);
        if (item.Message === 'Success') {
          // this.isLoaded = true;
          this.getPagedApiData();
        }
      }
    }));
  }

  generate() {
    this.checkSelected();
    this.checkPost();
  }

  generateRow(row: any) {
    this.confirmDialogService.confirmThis(
      [$localize`:Generate recurring entry?@@generateRecurringConfirm:Generate a new entry from this recurring template?`],
      () => {
        const payload = [{header_id: row.id}];
        this.tableDataService.post('recurring', payload).subscribe(
          (item: any) => {
            if (item && item.message === 'Conflict') {
              this.notification.showWarningToast(
                $localize`:Already generated@@alreadyGenerated:This recurring entry has already been generated for this period.`
              );
            }
            this.search();
          },
          (error: any) => {
            console.log(error.statusText);
          }
        );
      },
      () => {
      }
    );
  }

  postEntries() {
    if (this.vm.recurring.length > 0) {
      this.tableDataService.post('recurring', this.vm.recurring).subscribe(
        (item: any) => {
          this.vm.buttonsDisabled = false;
          this.checkAll = false;
          if (item && item.message === 'Conflict') {
            this.notification.showWarningToast(
              $localize`:Already generated@@alreadyGenerated:This recurring entry has already been generated for this period.`
            );
          }
          this.search();
        },
        (error: any) => {
          this.vm.buttonsDisabled = false;
          console.log(error.statusText);
        }
      );
    }
  }

  onNavigate(id: any) {
    // console.log('id:' + id);
    this.tableDataService
      .getApiListData('entity?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        // this.localStorage.StorageSet('entity', JSON.stringify(result.Data));
        if (this.vm.type === 'ar') {
          this.router.navigate(['/transactions/invoice/ar/form'], {queryParams: {invoiceId: id}}).then();
        } else if (this.vm.type === 'ap') {
          this.router.navigate(['/transactions/invoice/ap/form'], {queryParams: {invoiceId: id}}).then();
        }
      });
  }

  checkPost() {
    if (this.vm.recurring.length === 0) {
      this.notification.showWarningToast(
        $localize`:You must select at least one entry @@youmustselectatleastoneentry:You must select at least one entry`
      );
      return;
    }
    const messages: string[] = [
      $localize`:Are you sure you want to Generate Entries? @@areyousureyouwanttogenerat4eentries:Are you sure you want to Generate Entries?`,
      'Selected Count: ' + this.vm.recurring.length,
    ];
    this.confirmDialogService.confirmThis(
      messages,
      () => {
        this.postEntries();
        // this.notification.success($localize`:Entries Created@@entriesCreated:Entries Created`);
      },
      () => {
        this.notification.showSuccessToast($localize`:Generate Canceled @@GenerateCanceled:Generate Canceled`);
      }
    );
  }

  // ----------------- Server side paging --------------------

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

  setStatusFilter(status: 'active' | 'completed' | 'all') {
    this.statusFilter = status;
    this.page = 1;
    this.getPagedApiData();
  }


  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    // this.vm.selectAllItems = false;
    this.checkAll = false;

    // if (this.vm.unappliedOnly) {
    //   this.vm.numberOfResults = 'All';
    // }

    if (this.vm.type === 'ap') {
      let paramString = '';
      paramString += 'batchType=4';
      paramString += '&recurring=1';
      paramString += '&recurring_status=' + this.statusFilter;
      paramString += '&search=' + (this.vm.invoiceSearch === undefined ? '' : this.vm.invoiceSearch);
      paramString += '&fromDate=' + (this.vm.invoiceFromDate ? this.dateFilter.GetDateFormat(this.vm.invoiceFromDate) : '');
      paramString += '&toDate=' + (this.vm.invoiceToDate ? this.dateFilter.GetDateFormat(this.vm.invoiceToDate) : '');
      paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
      paramString += '&pageSize=' + this.pageSize;

      this.tableDataService.getApiListData('entry', '?' + paramString).subscribe((result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.vm.listInitiated = true;
      });
    } else {
      let paramString = '';
      paramString += 'batchType=2';
      paramString += '&recurring=1';
      paramString += '&recurring_status=' + this.statusFilter;
      paramString += '&search=' + (this.vm.invoiceSearch === undefined ? '' : this.vm.invoiceSearch);
      paramString += '&fromDate=' + (this.vm.invoiceFromDate ? this.dateFilter.GetDateFormat(this.vm.invoiceFromDate) : '');
      paramString += '&toDate=' + (this.vm.invoiceToDate ? this.dateFilter.GetDateFormat(this.vm.invoiceToDate) : '');
      paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
      paramString += '&pageSize=' + this.pageSize;

      this.tableDataService.getApiListData('entry', '?' + paramString).subscribe((result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.vm.listInitiated = true;
      });
    }
  }

  serverSearch(value) {
    this.vm.invoiceSearch = value.searchTerm;
    this.vm.invoiceFromDate = value.fromDate;
    this.vm.invoiceToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.invoiceSearch = value.searchTerm;
    this.vm.invoiceFromDate = value.fromDate;
    this.vm.invoiceToDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }
}
